import dayjs, { Dayjs } from 'dayjs'

// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export interface PagingMetadata {
  page: number
  pageSize: number
  totalPages: number
  totalItems: number
  message: string
}

export function dayStrOrDateToDayString(dayStrOrDate: string | Date | Dayjs): string {
  if (dayjs.isDayjs && dayjs.isDayjs(dayStrOrDate)) {
    return dayStrOrDate.format('YYYY-MM-DD')
  }
  if (typeof dayStrOrDate === 'string') {
    return dayStrOrDate
  }
  return dayjs(dayStrOrDate).format('YYYY-MM-DD')
}
